"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userManagementUrl = exports.userGroupManagementUrl = exports.supportUrl = exports.ofakimApiUrl = exports.lo = exports.learningUrl = exports.environmentUrl = exports.cdnUrl = exports.apiGatewayUrl = void 0;
var _cetEnvironment = require("./cetEnvironment");
const cetDomain = (0, _cetEnvironment.getCetEnvironmentInfo)().cetDomain;
const apiGatewayUrl = exports.apiGatewayUrl = `https://apigateway.${cetDomain}`;
const cdnUrl = exports.cdnUrl = `https://cdn.${cetDomain}`;
const lo = exports.lo = `https://lo.${cetDomain}`;
const learningUrl = exports.learningUrl = `https://learning.${cetDomain}`;
const ofakimApiUrl = exports.ofakimApiUrl = `https://ebag.${cetDomain}/api`;
const environmentUrl = exports.environmentUrl = `https://environment.${cetDomain}/api`;
const supportUrl = exports.supportUrl = `https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar`;
const userManagementUrl = exports.userManagementUrl = `https://ofek.${cetDomain}/SchoolManager/MemberData.aspx`;
const userGroupManagementUrl = exports.userGroupManagementUrl = `https://ofek.${cetDomain}/SchoolManager/TeamData.aspx?PrevPage=ClassList&DisplayType=AddGroup`;